/*
 * Departure fallback position
 *
 * Departure default when the planner vessel has no reported position: the
 * vessel's current position along its plan route (active first, else the
 * newest suggested one — resolved by usePlannerVoyage from the RouteStore).
 */

import {
  buildVesselsGeojson,
  vesselRecenterPoint,
} from "@/utils/vesselHelper.jsx";
import { isValidLonLat } from "@/features/route/state/RouteSelectors.jsx";

// Current position along route point features (shape of
// selectRoutePointsGeojson); untimed routes yield the first point (a departure
// default must not point at the destination).
export function positionAlongRoutePointFeatures(features, atMs) {
  const valid = (features ?? []).filter((f) =>
    isValidLonLat(f?.geometry?.coordinates),
  );
  if (valid.length === 0) return null;
  if (!valid.some((f) => f.properties?.timestamp != null)) {
    return valid[0].geometry.coordinates;
  }

  // Interpolate like the map's vessel icon — the nearest waypoint can sit
  // hours away on sparse routes.
  const route = { points: { geojson: { features: valid } } };
  const [vessel] = buildVesselsGeojson({
    routes: [route],
    sliderPosition: { label: new Date(atMs).toISOString() },
  });
  const coords = vessel?.points?.geojson?.features?.[0]?.geometry?.coordinates;
  return isValidLonLat(coords) ? coords : vesselRecenterPoint(route, atMs);
}
